import { format, parse } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import React from 'react'
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis
} from 'recharts'

import ellipseVerde from '../../../icones/iconesVersaoVerde/ellipse.svg'
import { formatarMilharSemDecimais } from '../../../utils/formatarMilhar'

import * as S from './styles'

const BAR_LENGTH = {
  1: 220,
  2: 140,
  3: 90,
  4: 65,
  5: 50,
  6: 45
}

const NUMBER_FORMAT = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
})

const formatDateToLabel = (date) => {
  const data = parse(date, 'MM/yyyy', new Date())
  const mes = format(data, 'MMMM', { locale: ptBR })
  const mesLabel = mes.charAt(0).toUpperCase() + mes.slice(1)

  return mesLabel.length > 4 ? mesLabel.substring(0, 3) : mesLabel
}

const formatComsumption = (value) => {
  if (value < 1) {
    const emMB = value * 1024
    return `${NUMBER_FORMAT.format(emMB)} MB`
  }

  return `${NUMBER_FORMAT.format(value)} GB`
}

const CustomTooltip = ({ payload, active }) => {
  if (!active || !payload?.length || !payload[0]?.payload) return null

  const {
    plano,
    operadora,
    consumoMes,
    consumoPercentual,
    mesReferencia,
    totalSimcard,
    totalSimcardUsado
  } = payload[0].payload

  const data = parse(mesReferencia, 'MM/yyyy', new Date())
  const mes = format(data, 'MMMM', { locale: ptBR })
  const mesLabel = mes.charAt(0).toUpperCase() + mes.slice(1)
  const operadoraLabel =
    operadora.charAt(0).toUpperCase() + operadora.slice(1).toLowerCase()

  const consumo = consumoMes
  const percentual = `(${NUMBER_FORMAT.format(consumoPercentual)}%)`

  return (
    <S.TooltipWrapper>
      <S.TooltipContent>
        <S.TituloTooltip>{mesLabel}</S.TituloTooltip>
        <S.TextTooltip>
          <S.ElipseWrapper>
            <S.Elipse src={ellipseVerde} alt="elipse" />
            {operadoraLabel}
          </S.ElipseWrapper>
          <div>
            {formatComsumption(consumo)}
            <S.Percentual> {percentual}</S.Percentual>
          </div>
        </S.TextTooltip>
        <S.TextTooltip>
          <S.PlanWrapper>Plano</S.PlanWrapper>
          <div>
            {operadoraLabel} {plano} MB
          </div>
        </S.TextTooltip>
        <S.TextTooltip>
          <S.PlanWrapper>Linhas com consumo no ciclo</S.PlanWrapper>
          <div>{formatarMilharSemDecimais(totalSimcardUsado)} linhas</div>
        </S.TextTooltip>
        <S.TextTooltip>
          <S.PlanWrapper>Linhas ativas no ciclo</S.PlanWrapper>
          <div>{formatarMilharSemDecimais(totalSimcard)} linhas</div>
        </S.TextTooltip>
      </S.TooltipContent>
    </S.TooltipWrapper>
  )
}

export default function Grafico({ data }) {
  const localTema = localStorage.getItem('tema')
  const gridColor = localTema === 'escuro' ? '#FFFFFF' : '#656565'
  const cartesianGridColor = '#8E8E8E'
  const filledBarColor = '#36D896'

  if (!data || !data.length) {
    return (
      <S.SemDados>
        Não foram encontrados dados para exibir no gráfico.
      </S.SemDados>
    )
  }

  return (
    <S.Container>
      <ResponsiveContainer>
        <BarChart
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
        >
          <CartesianGrid stroke={cartesianGridColor} strokeDasharray="5 5" />
          <XAxis
            stroke={gridColor}
            dataKey="mesReferencia"
            tickFormatter={(mesReferencia) => formatDateToLabel(mesReferencia)}
          />
          <Tooltip
            cursor={{ fill: 'transparent' }}
            content={<CustomTooltip />}
          />
          <Bar
            barSize={BAR_LENGTH[data.length]}
            dataKey="consumoMes"
            fill="#36D896"
            radius={[5, 0, 0, 2]}
            isAnimationActive
            animationDuration={800}
            animationEasing="ease-out"
          >
            {data.map((item, index) => (
              <Cell key={`cell-${index}`} fill={filledBarColor} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </S.Container>
  )
}
